import React, { useState, useEffect, Suspense } from "react";

import {
  Route,
  Routes,
  Navigate,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";

import i18n from "common/i18n/i18n";
import api from "common/utils/api";
import { sideBarWidth } from "common/const/const";
import { roleAccessEnum } from "common/enum/RoleAccessEnum";
// import { useState, useEffect } from "react";
// import { ErrorScreen } from "common/views";
// import { SideBar } from "common/components";
// import { Header } from "common/components/Header/header.jsx";
// import {
//   LoginScreen,
//   ResetPwScreen,
//   ToResetPwScreen,
//   SelectTypeScreen,
//   VerifiedEmail,
// } from "pages/Login";
// import { SignUpBusinessScreen, SignUpEmployeeScreen } from "pages/SignUp";
// import { WelcomeMapScreen } from "pages/Map";
// import { MyProfileScreen } from "pages/Profile";
// import { HomeErrorScreen, HomeScreen } from "pages/Home";
// import { GolfInfoScreen } from "pages/Information";
// import { ClientListScreen, ClientProfileScreen } from "pages/Client";
// import { AddScheduleScreen, PriceScheduleScreen } from "pages/Schedule";
// import {
//   OfflineReservationScreen,
//   ReservationListScreen,
//   ReservationTableScreen,
// } from "pages/Reservation";
// import { AddStaffScreen, EditStaffScreen, StaffListScreen } from "pages/Staff";

// import { AddRoleScreen, EditRoleScreen, SettingRoleScreen } from "pages/Role";
// import MembershipList from "pages/Membership/MembershipList";
import { DesignPage } from "common/views/DesignPage";
import { ModalProvider } from "common/components/Wrapper/ModalProvider";
import { modalRef, showMessageModal } from "common/utils/modalController"; // 경로 확인

// import { useAccessManager } from "common/hooks/useAccessManager";

import { getPermissions, isBusinessOwner } from "common/store/userSession";

import "./App.css";
import "common/css/common.css";
import "common/css/reset.css";
import "common/css/style.css";

import { ErrorScreen } from "common/views";
import { SideBar } from "common/components";
import { Header } from "common/components/Header/header";
import VerifyPasswordScreen from "pages/Login/VerifyPasswordScreen";
import { GlobalProvider } from "common/data/GlobalContext";
import { MobilePage } from "common/views/MobilePage";
import { SalesChartScreen } from "pages/Sales/SalesChartScreen";
import { SalesDetailListScreen } from "pages/Sales/SalesDetailListScreen";

// Lazy loading for components
// const LoginScreen = React.lazy(() => import("pages/Login/LoginScreen"));
const ResetPwScreen = React.lazy(() => import("pages/Login/ResetPwScreen"));
const ToResetPwScreen = React.lazy(() => import("pages/Login/ToResetPwScreen"));
const SelectTypeScreen = React.lazy(
  () => import("pages/Login/SelectTypeScreen"),
);
const VerifiedEmail = React.lazy(() => import("pages/Login/VerifiedEmail"));

const SignUpBusinessScreen = React.lazy(
  () => import("pages/SignUp/SignUpBusinessScreen"),
);
const SignUpEmployeeScreen = React.lazy(
  () => import("pages/SignUp/SignUpEmployeeScreen"),
);

const WelcomeMapScreen = React.lazy(() => import("pages/Map/WelcomeMapScreen"));
const MyProfileScreen = React.lazy(
  () => import("pages/Profile/MyProfileScreen"),
);

const EmailVerificationScreen = React.lazy(
  () => import("pages/Home/HomeErrorScreen"),
);
const HomeErrorScreen = React.lazy(() => import("pages/Home/HomeErrorScreen"));
const HomeScreen = React.lazy(() => import("pages/Home/HomeScreen"));

const GolfInfoScreen = React.lazy(
  () => import("pages/Information/GolfInfoScreen"),
);
const ClientListScreen = React.lazy(
  () => import("pages/Client/ClientListScreen"),
);
const ClientProfileScreen = React.lazy(
  () => import("pages/Client/ClientProfileScreen"),
);

const AddScheduleScreen = React.lazy(
  () => import("pages/Schedule/AddScheduleScreen"),
);
const PriceScheduleScreen = React.lazy(
  () => import("pages/Schedule/PriceScheduleScreen"),
);

const ScheduleStatsScreen = React.lazy(
  () => import("pages/Schedule/ScheduleStatsScreen"),
);

// const OfflineReservationScreen = React.lazy(
//   () => import("pages/Reservation/OfflineReservationScreen")
// );
const ReservationListScreen = React.lazy(
  () => import("pages/Reservation/ReservationListScreen"),
);
const ReservationTableScreen = React.lazy(
  () => import("pages/Reservation/ReservationTableScreen"),
);

const AddStaffScreen = React.lazy(() => import("pages/Staff/AddStaffScreen"));
const EditStaffScreen = React.lazy(() => import("pages/Staff/EditStaffScreen"));
const StaffListScreen = React.lazy(() => import("pages/Staff/StaffListScreen"));
const StaffListAllScreen = React.lazy(
  () => import("pages/Staff/StaffListScreen"),
);

const AddRoleScreen = React.lazy(() => import("pages/Role/AddRoleScreen"));
const EditRoleScreen = React.lazy(() => import("pages/Role/EditRoleScreen"));
const SettingRoleScreen = React.lazy(
  () => import("pages/Role/SettingRoleScreen"),
);

const MembershipEditScreen = React.lazy(
  () => import("pages/Membership/MembershipEditScreen"),
);
const MembershipListScreen = React.lazy(
  () => import("pages/Membership/MembershipListScreen"),
);

const CustomerListScreen = React.lazy(
  () => import("pages/Customer/CustomerListScreen"),
);
const CustomerEditScreen = React.lazy(
  () => import("pages/Customer/CustomerEditScreen"),
);

const CourseInfoListScreen = React.lazy(
  () => import("pages/Information/CourseInfoListScreen"),
);

const CourseInfoEditScreen = React.lazy(
  () => import("pages/Information/CourseInfoEditScreen"),
);

const TeeTimeInfoListScreen = React.lazy(
  () => import("pages/Information/TeeTimeInfoListScreen"),
);

const TeeTimeInfoEditScreen = React.lazy(
  () => import("pages/Information/TeeTimeInfoEditScreen"),
);

const PriceInfoListScreen = React.lazy(
  () => import("pages/Information/PriceInfoListScreen"),
);

const PriceInfoEditScreen = React.lazy(
  () => import("pages/Information/PriceInfoEditScreen"),
);

const ChargeInfoListScreen = React.lazy(
  () => import("pages/Charges/ChargeInfoListScreen"),
);

const ChargeInfoEditScreen = React.lazy(
  () => import("pages/Charges/ChargeInfoEditScreen"),
);

const ChargeCategoryEditScreen = React.lazy(
  () => import("pages/Charges/ChargeCategoryEditScreen"),
);

const ForwardScreen = React.lazy(() => import("pages/Forward/ForwardScreen"));

function App() {
  const [isSideBar, setIsSideBar] = useState(false);
  const [isStaticHeader, setIsStaticHeader] = useState(false);
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [club, setClub] = useState(sessionStorage.getItem("clubId") || "");
  const [roleName, setRoleName] = useState("");
  const [homeAccess, setHomeAccess] = useState(true);
  const [clubAccess, setClubAccess] = useState(false);
  const [roleAcess, setRoleAccess] = useState(false);
  const [staffAccess, setStaffAccess] = useState(false);
  const [reservationAccess, setReservationAccess] = useState(false);
  const [salesAccess, setSalesAccess] = useState(false);
  const [membershipAccess, setMembershipAccess] = useState(false);
  const [clientAccess, setClientAccess] = useState(false);
  const [staffAll, setStaffAll] = useState(false);
  const [clubImageRef, setClubImageRef] = useState();
  const [clubName, setClubName] = useState("");
  const [userName, setUserName] = useState("");
  const [isProfile, setIsProfile] = useState(true);
  window.setClub = setClub;

  const getUserRole = async () => {
    try {
      const res = await api.get("/api/v1.0/users/role?clubId=" + club);
      return res.data.result;
    } catch (error) {
      console.log(error);
      setRoleName("");
    }
  };

  const initClubName = () => {
    api
      .get("/api/v2.0/club?clubId=" + club)
      .then((res) => {
        const clubData = res.data.club;
        setClubName(clubData.name);
        setClubImageRef(clubData?.imageRefs?.[0].imageRef);

        sessionStorage.setItem("clubId", clubData.id);
        sessionStorage.setItem("country", clubData.country);
        sessionStorage.setItem("clubName", clubData.name);
      })
      .catch((error) => {
        setClubName("");
        console.log(error);
      });
  };

  const getAdmin = async () => {
    try {
      const res = await api.get("/api/v1.0/sign-in/isAdmin");
      return res?.data?.result?.isAdmin;
    } catch (error) {
      console.log(error);
    }
  };

  const setAccessForUser = ([
    home,
    club,
    staff,
    role,
    reservation,
    sales,
    membership,
    client,
    staffAll,
  ]) => {
    setHomeAccess(home);
    setClubAccess(club);
    setRoleAccess(role);
    setStaffAccess(staff);
    setReservationAccess(reservation);
    setSalesAccess(sales);
    setMembershipAccess(membership);
    setClientAccess(client);
    setStaffAll(staffAll);
  };

  const checkRoleAccess = (userRoleList) => {
    const accessFlags = {
      isStaffList: false,
      isReservation: false,
      isClubInformation: false,
      isMembershipAccess: false,
    };

    userRoleList.forEach((role) => {
      switch (role.accessCode) {
        case roleAccessEnum.STAFF_LIST:
          accessFlags.isStaffList = true;
          break;
        case roleAccessEnum.RESERVATION:
          accessFlags.isReservation = true;
          break;
        case roleAccessEnum.CLUB_INFORMATION:
          accessFlags.isClubInformation = true;
          break;
        case roleAccessEnum.MEMBERSHIP_MANAGEMENT:
          accessFlags.isMembershipAccess = true;
          break;
        default:
          break;
      }
    });

    return accessFlags;
  };

  const initRole = async () => {
    const pageType = searchParams.get("pageType");
    const isClubOwner = Object.values(getPermissions() || {}).some(
      (club) => club.isOwner === true,
    );
    const checkAdmin = await getAdmin();

    if (
      location.pathname === "/home" ||
      location.pathname === "/staff-all" ||
      pageType === "staff-all"
    ) {
      setIsProfile(false);
      setAccessForUser([
        true,
        false,
        false,
        false,
        false,
        true,
        false,
        false,
        isClubOwner, // 모든 스태프 조회는 골프장 사업주만 노출
      ]);
      return;
    }

    if (checkAdmin) {
      // 관리자
      setRoleName("admin");
      setIsProfile(true);
      setAccessForUser([true, true, true, true, true, true, true, true, false]);
      return;
    }

    const userRole = await getUserRole();

    if (!(userRole && userRole.list.length > 0)) {
      setRoleName("");
      setIsProfile(false);
      setAccessForUser([
        true,
        false,
        false,
        false,
        false,
        true,
        false,
        false,
        false,
      ]);
      return;
    }

    const isClubManager = userRole.roleAccessCnt === userRole.roleAccessKindCnt;
    setRoleName(userRole.list[0].roleName);
    setIsProfile(true);

    if (isClubManager) {
      // 모든 권한 부여된 사용자
      setAccessForUser([
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        false,
        false,
      ]);
    } else {
      // 일반 사용자
      const {
        isStaffList,
        isRoleSetting,
        isReservation,
        isClubInformation,
        isMembershipAccess,
      } = checkRoleAccess(userRole.list);
      setAccessForUser([
        true,
        isClubInformation,
        isStaffList,
        isRoleSetting,
        isReservation,
        true,
        isMembershipAccess,
        false,
        false,
      ]);
    }
  };

  useEffect(() => {
    if (
      [
        "/",
        "/mobile-view",
        "/reset-password",
        "/verify-password",
        "/select-account-type",
        "/sign-up-business",
        "/sign-up-employee",
        "/welcome",
        "/home-error",
        "/client-profile",
        "/reservation-detail",
        "/signup/verify",
        "/error",
        "/forward",
        "/email-verification",
      ].includes(location.pathname) ||
      location.pathname.includes("/profile") ||
      location.pathname.includes("/resetpw")
    ) {
      setIsSideBar(false);
    } else {
      setIsSideBar(true);
    }
  }, [location, location.pathname, navigate]);

  useEffect(() => {
    initRole();
    initClubName();
    setClubImageRef(sessionStorage.getItem("clubImageRef"));
  }, [club, isSideBar, navigate]);
  // useAccessManager(
  //   club,
  //   setRoleName,
  //   window.setAccess,
  //   setClubName,
  //   setClubImageRef
  // );

  return (
    <div className="App">
      <link
        rel="stylesheet"
        href="https://unpkg.com/leaflet@1.0.1/dist/leaflet.css"
      />
      <GlobalProvider>
        <Suspense>
          <ModalProvider ref={modalRef}>
            {isSideBar ? (
              // <ModalProvider>
              //   {showSideBar ? (
              <SideBar
                clubImageRef={clubImageRef}
                access={[
                  homeAccess,
                  clubAccess,
                  reservationAccess,
                  salesAccess,
                  membershipAccess,
                  staffAccess,
                  staffAll,
                  clientAccess,
                ]}
                roleName={roleName}
                clubName={clubName}
                clubId={club}
                isProfile={isProfile}
              />
            ) : null}
            <main>
              {location.pathname !== "/mobile-view" && (
                <Header
                  isStatic={
                    !["/mobile-view", "/welcome"].includes(location.pathname) &&
                    isSideBar
                  }
                />
              )}
              <MobilePage />
              <Routes>
                <Route path="/" element={<Navigate to="/welcome" />} />
                <Route path="/welcome" element={<WelcomeMapScreen />} />
                {homeAccess && <Route path="/home" element={<HomeScreen />} />}
                <Route path="/home-error" element={<HomeErrorScreen />} />
                <Route
                  path="/email-verification"
                  element={<EmailVerificationScreen />}
                />
                {/* <Route path="/" element={<LoginScreen />} /> */}
                <Route path="/reset-password" element={<ResetPwScreen />} />
                <Route path="/resetpw" element={<ToResetPwScreen />} />
                <Route
                  path="/verify-password"
                  element={<VerifyPasswordScreen />}
                />
                <Route
                  path="/select-account-type"
                  element={<SelectTypeScreen />}
                />
                <Route
                  path="/sign-up-business"
                  element={<SignUpBusinessScreen />}
                />
                <Route
                  path="/sign-up-employee"
                  element={<SignUpEmployeeScreen />}
                />
                <Route path="/add-golf-club" element={<GolfInfoScreen />} />
                <Route path="/profile" element={<MyProfileScreen />} />
                <Route path="/golf-info" element={<GolfInfoScreen />} />
                <Route path="/client" element={<ClientListScreen />} />
                <Route
                  path="/client-profile"
                  element={<ClientProfileScreen />}
                />
                <Route path="/sales" element={<SalesChartScreen />} />
                <Route
                  path="/sales-detail"
                  element={<SalesDetailListScreen />}
                />
                <Route
                  path="/reservation"
                  element={<ReservationListScreen />}
                />
                <Route path="/signup/verify" element={<VerifiedEmail />} />
                <Route
                  path="/reservation-table"
                  element={<ReservationTableScreen />}
                />
                {/* <Route
                  path="/offline-reservation"
                  element={<OfflineReservationScreen />}
                /> */}
                <Route path="/setting-role" element={<SettingRoleScreen />} />
                <Route path="/add-role" element={<AddRoleScreen />} />
                <Route path="/edit-role" element={<EditRoleScreen />} />
                <Route path="/add-schedule" element={<AddScheduleScreen />} />
                <Route
                  path="/price-schedule"
                  element={<PriceScheduleScreen />}
                />
                <Route path="/Insights" element={<ScheduleStatsScreen />} />
                <Route path="/staff-all" element={<StaffListAllScreen />} />
                <Route path="/staff" element={<StaffListScreen />} />
                <Route path="/add-staff" element={<AddStaffScreen />} />
                <Route path="/edit-staff" element={<EditStaffScreen />} />
                <Route
                  path="/membership-tiers"
                  element={<MembershipListScreen />}
                />
                <Route
                  path="/membership-create"
                  element={<MembershipEditScreen />}
                />
                <Route
                  path="/membership-update"
                  element={<MembershipEditScreen />}
                />
                <Route path="/customer-list" element={<CustomerListScreen />} />
                <Route
                  path="/customer-create"
                  element={<CustomerEditScreen />}
                />
                <Route
                  path="/customer-update"
                  element={<CustomerEditScreen />}
                />

                <Route path="/course-list" element={<CourseInfoListScreen />} />
                <Route
                  path="/course-create"
                  element={<CourseInfoEditScreen />}
                />
                <Route
                  path="/course-update"
                  element={<CourseInfoEditScreen />}
                />

                <Route path="/tee-time" element={<TeeTimeInfoListScreen />} />
                <Route
                  path="/tee-time-create"
                  element={<TeeTimeInfoEditScreen />}
                />
                <Route
                  path="/tee-time-update"
                  element={<TeeTimeInfoEditScreen />}
                />

                <Route path="/price-list" element={<PriceInfoListScreen />} />
                <Route path="/price-create" element={<PriceInfoEditScreen />} />
                <Route path="/price-update" element={<PriceInfoEditScreen />} />

                <Route path="/charge-list" element={<ChargeInfoListScreen />} />
                <Route path="/charge-edit" element={<ChargeInfoEditScreen />} />
                <Route
                  path="/charge-category-edit"
                  element={<ChargeCategoryEditScreen />}
                />

                <Route path="/forward" element={<ForwardScreen />} />
                <Route path="*" element={<Navigate to="/error" />} />
                <Route path="/error" element={<ErrorScreen />} />
                <Route path="/designs" element={<DesignPage />} />
              </Routes>
            </main>
          </ModalProvider>
        </Suspense>
        {/* />
        ) : null}
        <main>
          <Header isStatic={showSideBar} />
          <Routes>
            <Route path="/" element={<Navigate to="/welcome" />} />
            <Route path="/welcome" element={<WelcomeMapScreen />} />
            {homeAccess && <Route path="/home" element={<HomeScreen />} />}
            <Route path="/home-error" element={<HomeErrorScreen />} />
            <Route path="/" element={<LoginScreen />} />
            <Route path="/reset-password" element={<ResetPwScreen />} />
            <Route path="/resetpw/*" element={<ToResetPwScreen />} />
            <Route path="/select-account-type" element={<SelectTypeScreen />} />
            <Route
              path="/sign-up-business"
              element={<SignUpBusinessScreen />}
            />
            <Route
              path="/sign-up-employee"
              element={<SignUpEmployeeScreen />}
            />
            <Route path="/add-golf-club" element={<GolfInfoScreen />} />
            <Route path="/profile" element={<MyProfileScreen />} />
            <Route path="/golf-info" element={<GolfInfoScreen />} />
            <Route path="/client" element={<ClientListScreen />} />
            <Route path="/client-profile" element={<ClientProfileScreen />} />
            <Route path="/reservation" element={<ReservationListScreen />} />
            <Route path="/signup/verify" element={<VerifiedEmail />} />
            <Route
              path="/reservation-table"
              element={<ReservationTableScreen />}
            />
            <Route
              path="/offline-reservation"
              element={<OfflineReservationScreen />}
            />
            <Route path="/setting-role" element={<SettingRoleScreen />} />
            <Route path="/add-role" element={<AddRoleScreen />} />
            <Route path="/edit-role" element={<EditRoleScreen />} />
            <Route path="/add-schedule" element={<AddScheduleScreen />} />
            <Route path="/price-schedule" element={<PriceScheduleScreen />} />
            <Route path="/staff" element={<StaffListScreen />} />
            <Route path="/add-staff" element={<AddStaffScreen />} />
            <Route path="/edit-staff" element={<EditStaffScreen />} />
            <Route path="/membership-tiers" element={<MembershipList />} />

            <Route path="*" element={<Navigate to="/error" />} />
            <Route path="/error" element={<ErrorScreen />} />
            <Route path="/designs" element={<DesignPage />} />
          </Routes>
        </main>
      </ModalProvider> */}
      </GlobalProvider>
    </div>
  );
}

export default App;
